export class AddFrequencyModel {
    ExecutionTime: string;
    DayOfMonth: number;
    DayOfWeek: number;
    StartMonth: number;

    constructor(
        ExecutionTime: string,
        DayOfMonth: number,
        DayOfWeek: number,
        StartMonth: number,
    ){
        this.ExecutionTime = ExecutionTime;
        this.DayOfMonth = DayOfMonth;
        this.DayOfWeek = DayOfWeek;
        this.StartMonth = StartMonth;
    }
}


// WEBPACK FOOTER //
// ./src/app/developer/components/service-subscription-editor/models/addFrequencyModel.ts